export const translations = {
  en: {
    name: "English",
    flag: "🇬🇧",
    // Navigation
    home: "Home",
    search: "Search",
    create: "Create",
    library: "Library",
    profile: "Profile",
    // Home
    goodMorning: "Good morning",
    goodAfternoon: "Good afternoon",
    goodEvening: "Good evening",
    welcomeBack: "Welcome back",
    recentlyPlayed: "Recently Played",
    seeAll: "See all",
    topHits: "Top Hits",
    browse: "Browse",
    trending: "Trending",
    myanmarArtists: "🇲🇲 Myanmar Artists",
    popularArtists: "Popular Artists",
    // Search
    searchPlaceholder: "Search songs, artists...",
    browseCategories: "Browse Categories",
    popularSearches: "Popular Searches",
    results: "results",
    searching: "Searching...",
    // Library
    yourLibrary: "Library",
    playlists: "playlists",
    likedSongs: "Liked Songs",
    newPlaylist: "New Playlist",
    following: "Following",
    playlist: "Playlist",
    songs: "songs",
    // Player
    nowPlaying: "Now Playing",
    related: "Related",
    lyrics: "Lyrics",
    key: "Key",
    relatedSongs: "Related Songs",
    loadingLyrics: "Loading lyrics...",
    lyricsNotAvailable: "Lyrics not available for this song yet.",
    analyzing: "Analyzing...",
    // Profile
    settings: "Settings",
    signOut: "Sign out",
    liked: "Liked",
    played: "Played",
    sleepTimer: "Sleep Timer",
    // About
    whoWeAre: "Who We Are",
    contactUs: "Contact Us",
    appInfo: "App Info",
    // Settings
    account: "Account",
    audio: "Audio",
    notifications: "Notifications",
    privacy: "Privacy",
    about: "About",
    language: "Language",
    changeLanguage: "Change Language",
    // General
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    close: "Close",
    back: "Back",
    loading: "Loading...",
    noResults: "No results found",
    addToPlaylist: "Add to Playlist",
    createPlaylist: "Create Playlist",
    playlistName: "Playlist name",
    artist: "Artist",
    album: "Album",
    follow: "+ Follow",
    following2: "✓ Following",
  },

  hi: {
    name: "हिंदी",
    flag: "🇮🇳",
    // Navigation
    home: "होम",
    search: "खोजें",
    create: "बनाएं",
    library: "लाइब्रेरी",
    profile: "प्रोफाइल",
    // Home
    goodMorning: "सुप्रभात",
    goodAfternoon: "नमस्ते",
    goodEvening: "शुभ संध्या",
    welcomeBack: "वापसी पर स्वागत",
    recentlyPlayed: "हाल ही में चलाया",
    seeAll: "सब देखें",
    topHits: "टॉप हिट्स",
    browse: "ब्राउज़ करें",
    trending: "ट्रेंडिंग",
    myanmarArtists: "🇲🇲 म्यांमार कलाकार",
    popularArtists: "लोकप्रिय कलाकार",
    // Search
    searchPlaceholder: "गाने, कलाकार खोजें...",
    browseCategories: "श्रेणियां ब्राउज़ करें",
    popularSearches: "लोकप्रिय खोजें",
    results: "परिणाम",
    searching: "खोज रहे हैं...",
    // Library
    yourLibrary: "लाइब्रेरी",
    playlists: "प्लेलिस्ट",
    likedSongs: "पसंदीदा गाने",
    newPlaylist: "नई प्लेलिस्ट",
    following: "फॉलो किया",
    playlist: "प्लेलिस्ट",
    songs: "गाने",
    // Player
    nowPlaying: "अभी चल रहा है",
    related: "संबंधित",
    lyrics: "गीत",
    key: "की",
    relatedSongs: "संबंधित गाने",
    loadingLyrics: "गीत लोड हो रहे हैं...",
    lyricsNotAvailable: "इस गाने के गीत उपलब्ध नहीं हैं।",
    analyzing: "विश्लेषण हो रहा है...",
    // Profile
    settings: "सेटिंग्स",
    signOut: "साइन आउट",
    liked: "पसंद",
    played: "चलाया",
    sleepTimer: "स्लीप टाइमर",
    // General
    cancel: "रद्द करें",
    save: "सहेजें",
    delete: "हटाएं",
    close: "बंद करें",
    back: "वापस",
    loading: "लोड हो रहा है...",
    noResults: "कोई परिणाम नहीं मिला",
    addToPlaylist: "प्लेलिस्ट में जोड़ें",
    createPlaylist: "प्लेलिस्ट बनाएं",
    playlistName: "प्लेलिस्ट का नाम",
    artist: "कलाकार",
    album: "एल्बम",
    follow: "+ फॉलो",
    following2: "✓ फॉलो किया",
    // About
    whoWeAre: "हम कौन हैं",
    contactUs: "संपर्क करें",
    appInfo: "ऐप जानकारी",
    // Settings
    account: "खाता",
    audio: "ऑडियो",
    notifications: "सूचनाएं",
    privacy: "गोपनीयता",
    about: "के बारे में",
    language: "भाषा",
    changeLanguage: "भाषा बदलें",
  },

  my: {
    name: "မြန်မာ",
    flag: "🇲🇲",
    // Navigation
    home: "ပင်မ",
    search: "ရှာဖွေ",
    create: "ဖန်တီး",
    library: "စာကြည့်တိုက်",
    profile: "ကိုယ်ရေး",
    // Home
    goodMorning: "မင်္ဂလာနံနက်ခင်း",
    goodAfternoon: "မင်္ဂလာနေ့လည်ခင်း",
    goodEvening: "မင်္ဂလာညနေ",
    welcomeBack: "ပြန်လာတာကြိုဆိုပါတယ်",
    recentlyPlayed: "မကြာမီ ဖွင့်ခဲ့သော",
    seeAll: "အားလုံး ကြည့်ရန်",
    topHits: "ထိပ်တန်း သီချင်းများ",
    browse: "ကြည့်ရှု",
    trending: "ခေတ်နှစ်သက်",
    myanmarArtists: "🇲🇲 မြန်မာ အနုပညာရှင်များ",
    popularArtists: "နာမည်ကြီး အနုပညာရှင်များ",
    // Search
    searchPlaceholder: "သီချင်း၊ အနုပညာရှင် ရှာဖွေ...",
    browseCategories: "အမျိုးအစားများ ကြည့်ရှု",
    popularSearches: "လူကြိုက်များသော ရှာဖွေမှုများ",
    results: "ရလဒ်များ",
    searching: "ရှာဖွေနေသည်...",
    // Library
    yourLibrary: "စာကြည့်တိုက်",
    playlists: "သီချင်းစာရင်းများ",
    likedSongs: "ကြိုက်သော သီချင်းများ",
    newPlaylist: "သီချင်းစာရင်း အသစ်",
    following: "လိုက်နာနေသော",
    playlist: "သီချင်းစာရင်း",
    songs: "သီချင်းများ",
    // Player
    nowPlaying: "ယခု ဖွင့်နေသည်",
    related: "ဆက်စပ်",
    lyrics: "သီချင်းစာသား",
    key: "သော့ချက်",
    relatedSongs: "ဆက်စပ် သီချင်းများ",
    loadingLyrics: "သီချင်းစာသား တင်နေသည်...",
    lyricsNotAvailable: "ဤသီချင်းအတွက် စာသားမရှိသေးပါ။",
    analyzing: "စစ်ဆေးနေသည်...",
    // Profile
    settings: "ဆက်တင်များ",
    signOut: "ထွက်ရန်",
    liked: "ကြိုက်",
    played: "ဖွင့်ခဲ့",
    sleepTimer: "အိပ်ချိန် တိုင်မာ",
    // General
    cancel: "မလုပ်တော့",
    save: "သိမ်းဆည်း",
    delete: "ဖျက်ရန်",
    close: "ပိတ်ရန်",
    back: "နောက်သို့",
    loading: "တင်နေသည်...",
    noResults: "ရလဒ် မတွေ့ပါ",
    addToPlaylist: "သီချင်းစာရင်းသို့ ထည့်ရန်",
    createPlaylist: "သီချင်းစာရင်း ဖန်တီး",
    playlistName: "သီချင်းစာရင်း အမည်",
    artist: "အနုပညာရှင်",
    album: "အယ်လ်ဘမ်",
    follow: "+ လိုက်နာ",
    following2: "✓ လိုက်နာနေသည်",
    // About
    whoWeAre: "ကျွန်ုပ်တို့ အကြောင်း",
    contactUs: "ဆက်သွယ်ရန်",
    appInfo: "အက်ပ် အချက်အလက်",
    // Settings
    account: "အကောင့်",
    audio: "အသံ",
    notifications: "အကြောင်းကြားချက်",
    privacy: "ကိုယ်ရေး",
    about: "အကြောင်း",
    language: "ဘာသာစကား",
    changeLanguage: "ဘာသာစကား ပြောင်းရန်",
  
},

  ko: {
    name: "한국어",
    flag: "🇰🇷",
    home: "홈",
    search: "검색",
    create: "만들기",
    library: "보관함",
    profile: "프로필",
    goodMorning: "좋은 아침이에요",
    goodAfternoon: "안녕하세요",
    goodEvening: "좋은 저녁이에요",
    welcomeBack: "돌아오신 것을 환영해요",
    recentlyPlayed: "최근 재생",
    seeAll: "전체 보기",
    topHits: "인기 곡",
    browse: "둘러보기",
    trending: "트렌딩",
    myanmarArtists: "🇲🇲 미얀마 아티스트",
    popularArtists: "인기 아티스트",
    searchPlaceholder: "노래, 아티스트 검색...",
    browseCategories: "카테고리 둘러보기",
    popularSearches: "인기 검색",
    results: "결과",
    searching: "검색 중...",
    yourLibrary: "보관함",
    playlists: "플레이리스트",
    likedSongs: "좋아요 한 노래",
    newPlaylist: "새 플레이리스트",
    following: "팔로잉",
    playlist: "플레이리스트",
    songs: "곡",
    nowPlaying: "지금 재생 중",
    related: "관련",
    lyrics: "가사",
    key: "키",
    relatedSongs: "관련 노래",
    loadingLyrics: "가사 불러오는 중...",
    lyricsNotAvailable: "이 노래의 가사를 찾을 수 없습니다.",
    analyzing: "분석 중...",
    settings: "설정",
    signOut: "로그아웃",
    liked: "좋아요",
    played: "재생",
    sleepTimer: "수면 타이머",
    whoWeAre: "우리에 대해",
    contactUs: "문의하기",
    appInfo: "앱 정보",
    account: "계정",
    audio: "오디오",
    notifications: "알림",
    privacy: "개인정보",
    about: "정보",
    language: "언어",
    changeLanguage: "언어 변경",
    cancel: "취소",
    save: "저장",
    delete: "삭제",
    close: "닫기",
    back: "뒤로",
    loading: "불러오는 중...",
    noResults: "결과 없음",
    addToPlaylist: "플레이리스트에 추가",
    createPlaylist: "플레이리스트 만들기",
    playlistName: "플레이리스트 이름",
    artist: "아티스트",
    album: "앨범",
    follow: "+ 팔로우",
    },

  ko: {
    name: "日本語",
    flag: "🇯🇵",
    home: "ホーム",
    search: "検索",
    create: "作成",
    library: "ライブラリ",
    profile: "プロフィール",
    goodMorning: "おはようございます",
    goodAfternoon: "こんにちは",
    goodEvening: "こんばんは",
    welcomeBack: "おかえりなさい",
    recentlyPlayed: "最近再生した曲",
    seeAll: "すべて見る",
    topHits: "トップヒット",
    browse: "ブラウズ",
    trending: "トレンド",
    myanmarArtists: "🇲🇲 ミャンマーアーティスト",
    popularArtists: "人気アーティスト",
    searchPlaceholder: "曲、アーティストを検索...",
    browseCategories: "カテゴリを探す",
    popularSearches: "人気の検索",
    results: "件の結果",
    searching: "検索中...",
    yourLibrary: "ライブラリ",
    playlists: "プレイリスト",
    likedSongs: "お気に入りの曲",
    newPlaylist: "新しいプレイリスト",
    following: "フォロー中",
    playlist: "プレイリスト",
    songs: "曲",
    nowPlaying: "再生中",
    related: "関連",
    lyrics: "歌詞",
    key: "キー",
    relatedSongs: "関連曲",
    loadingLyrics: "歌詞を読み込み中...",
    lyricsNotAvailable: "この曲の歌詞はまだありません。",
    analyzing: "分析中...",
    settings: "設定",
    signOut: "サインアウト",
    liked: "いいね",
    played: "再生",
    sleepTimer: "スリープタイマー",
    whoWeAre: "私たちについて",
    contactUs: "お問い合わせ",
    appInfo: "アプリ情報",
    account: "アカウント",
    audio: "オーディオ",
    notifications: "通知",
    privacy: "プライバシー",
    about: "について",
    language: "言語",
    changeLanguage: "言語を変更",
    cancel: "キャンセル",
    save: "保存",
    delete: "削除",
    close: "閉じる",
    back: "戻る",
    loading: "読み込み中...",
    noResults: "結果なし",
    addToPlaylist: "プレイリストに追加",
    createPlaylist: "プレイリストを作成",
    playlistName: "プレイリスト名",
    artist: "アーティスト",
    album: "アルバム",
    follow: "+ フォロー",
    following2: "✓ フォロー中",
  },
};

export function getTranslation(lang) {
  return translations[lang] || translations.en;
}